export default "__VITE_ASSET__6db19759__"